(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.section = null;
      this.placeholder = null;
      this.headerTop = 0;
      this.headerHeight = 0;
      this.isFixed = false;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.updateMeasurements = this.updateMeasurements.bind(this);
    }

    connectedCallback() {
      /*
       * Shopify 2.0 的 section id 可能是动态的，
       * 不再依赖 #shopify-section-header。
       */
      this.section =
        this.closest('.section-header') ||
        this.closest('.shopify-section');

      if (!this.section) {
        console.warn('StickyHeader: section not found');
        return;
      }

      /*
       * fixed 会让 Header 脱离文档流，
       * 用占位元素防止页面内容突然向上跳。
       */
      this.placeholder = document.createElement('div');
      this.placeholder.className = 'header-sticky-placeholder';
      this.placeholder.setAttribute('aria-hidden', 'true');
      this.section.insertAdjacentElement('afterend', this.placeholder);

      this.updateMeasurements();

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('load', this.updateMeasurements, { once: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.updatePlaceholderHeight();
        });
        this.resizeObserver.observe(this);
      }

      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('load', this.updateMeasurements);

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.placeholder && this.placeholder.parentNode) {
        this.placeholder.remove();
      }
    }

    getScrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    updatePlaceholderHeight() {
      if (!this.section || !this.placeholder) return;

      const sectionHeight = this.section.offsetHeight;
      const computed = window.getComputedStyle(this.section);
      const marginBottom = parseFloat(computed.marginBottom) || 0;

      this.headerHeight = sectionHeight;
      this.placeholder.style.height = `${sectionHeight + marginBottom}px`;
    }

    updateMeasurements() {
      if (!this.section || !this.placeholder) return;

      const wasFixed = this.section.classList.contains('header-fixed');

      if (wasFixed) {
        this.section.classList.remove('header-fixed');
        this.placeholder.classList.remove('is-active');
        this.isFixed = false;
      }

      const rect = this.section.getBoundingClientRect();
      this.headerTop = rect.top + this.getScrollTop();

      this.updatePlaceholderHeight();
      this.handleScroll();
    }

    handleResize() {
      this.updateMeasurements();
    }

    handleScroll() {
      if (!this.section || !this.placeholder) return;

      const scrollTop = this.getScrollTop();

      if (scrollTop >= this.headerTop) {
        this.setFixed();
      } else {
        this.removeFixed();
      }
    }

    setFixed() {
      if (this.isFixed) return;

      this.updatePlaceholderHeight();
      this.placeholder.classList.add('is-active');
      this.section.classList.add('header-fixed');
      this.isFixed = true;
    }

    removeFixed() {
      if (!this.isFixed && !this.section.classList.contains('header-fixed')) return;

      this.section.classList.remove('header-fixed');
      this.placeholder.classList.remove('is-active');
      this.isFixed = false;
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
